import React from 'react';

import SelfSchemaViewer from '../../components/Rbac/SchemaViewer/SelfSchemaViewer';

function SelfView() {
  return <SelfSchemaViewer />;
}

export default SelfView;
